var React = require('react');

function IconChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("polygon",{"id":"path-1","points":"226.522267 12 231.477733 16.9446694 236.433198 12 237.955466 13.5222672 231.477733 20 225 13.5222672"})),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-1383.000000, -325.000000)"},React.createElement("g",{"transform":"translate(1158.000000, 313.000000)"},[React.createElement("mask",{"fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-1"})),React.createElement("use",{"fill":"currentColor","xlinkHref":"#path-1","key":1})])))]);
}

IconChevronDown.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8"};

module.exports = IconChevronDown;

IconChevronDown.default = IconChevronDown;
